import { render } from "./AgendSC.vue?vue&type=template&id=609d3057&scoped=true"
import script from "./AgendSC.vue?vue&type=script&lang=js"
export * from "./AgendSC.vue?vue&type=script&lang=js"

import "./AgendSC.vue?vue&type=style&index=0&id=609d3057&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609d3057"]])

export default __exports__